<highcharts-chart [constructorType]="chartConstructor"
                  [options]="(chartOptions$ | async)!"
                  [oneToOne]="true"
                  style="width: 100%; display: block;"></highcharts-chart>